/* eslint-disable import/no-anonymous-default-export */
import CenterDCBReportActionTypes from './center-DCB-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getCenterDCBReportListResponse: null,
	getCenterDCBReportListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_SUCCESS:
			return {
				...state,
				getCenterDCBReportListResponse: action.payload,
				getCenterDCBReportListArr: docodeHexResponse(
					action.payload,
					'CenterDCBReportListKey',
				),
			};
		case CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_FAILURE:
			return { ...state, getCenterDCBReportListResponse: action.payload };
		case CenterDCBReportActionTypes.FETCH_CENTER_DCB_REPORT_RESPONSE_CHANGED:
			return { ...state, getCenterDCBReportListResponse: null };
		default:
			return state;
	}
};
